import { FormBuilderPaymentOptions } from './form-builder-payment-options.model';
import { FormTypeEnum } from './form-type-enum.model';
import { FormBuilderCommunicationOptions } from './form-builder-communication-options.model';
import { FormBuilderNotificationEmail } from './form-builder-notification-email.model';
import { ProfileOrgIndEnum } from './profile-org-ind-enum.model';
//import { publicDecrypt } from "crypto";
//import { transform } from "typescript";

export class FormBuilderSettings {
  public ActivityTypeId: number;
  public FormPaymentOptions: FormBuilderPaymentOptions;
  public FormOrgIndEnum: ProfileOrgIndEnum;
  public FormType: FormTypeEnum;
  public NotificationEmails: Array<FormBuilderNotificationEmail>;
  public CommunicationOptions: FormBuilderCommunicationOptions;
  public AffCodesToApply: string[];

  public constructor() {
    this.ActivityTypeId = 0;
    this.FormType = FormTypeEnum.Undefined;
    this.FormPaymentOptions = new FormBuilderPaymentOptions();
    this.CommunicationOptions = new FormBuilderCommunicationOptions();
    this.FormOrgIndEnum = ProfileOrgIndEnum.Organization;
    this.NotificationEmails = [];
    this.AffCodesToApply = [];
  }
}
